/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";

const initState = {
    open: false,
    linkId: 0,
    linkName: "",
    pipelineStep: {},
};

const PipelineStepModalContext = React.createContext(initState);
export const usePipelineStepModalData = () =>
    React.useContext(PipelineStepModalContext);

const PipelineStepModalSwitchContext = React.createContext(() => {});
export const useSwitchPipelineStepModalData = () =>
    React.useContext(PipelineStepModalSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <PipelineStepModalContext.Provider value={value}>
            <PipelineStepModalSwitchContext.Provider
                value={(value) => {
                    if (typeof value === "function") setValue(value);
                    else if (typeof value === "object")
                        setValue((state) => ({ ...state, ...value }));
                }}
            >
                {children}
            </PipelineStepModalSwitchContext.Provider>
        </PipelineStepModalContext.Provider>
    );
};
